var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageOverlaySectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0002 19.8C20.3375 19.8 19.8002 20.3372 19.8002 21V35C19.8002 35.5609 20.1852 36.032 20.7053 36.1635L31.4345 25.4343C31.7469 25.1218 32.2535 25.1218 32.5659 25.4343L36.2002 29.0686V21C36.2002 20.3372 35.6629 19.8 35.0002 19.8H21.0002ZM36.2002 31.3313L32.0002 27.1313L22.9316 36.2H35.0002C35.6629 36.2 36.2002 35.6627 36.2002 35V31.3313ZM18.2002 21C18.2002 19.4536 19.4538 18.2 21.0002 18.2H35.0002C36.5466 18.2 37.8002 19.4536 37.8002 21V35C37.8002 36.5463 36.5466 37.7999 35.0002 37.7999H21.0002C19.4538 37.7999 18.2002 36.5463 18.2002 35V21ZM24.5002 24C24.2241 24 24.0002 24.2238 24.0002 24.5C24.0002 24.7761 24.2241 25 24.5002 25C24.7764 25 25.0002 24.7761 25.0002 24.5C25.0002 24.2238 24.7764 24 24.5002 24ZM22.0002 24.5C22.0002 23.1192 23.1195 22 24.5002 22C25.881 22 27.0002 23.1192 27.0002 24.5C27.0002 25.8807 25.881 27 24.5002 27C23.1195 27 22.0002 25.8807 22.0002 24.5Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOverlaySectionIcon);
export default __webpack_public_path__ + "static/media/image-overlay-section-icon.747270b46c823606a5f589bc4d874a3d.svg";
export { ForwardRef as ReactComponent };